/**
 * Where the client pages live, and what the drafts under no client are called.
 * One place, so the landing card, the hub, the header's trail and the rail's
 * link agree on both.
 */

export const CLIENTS_PATH = "/clients";

/** The legal documents, one card each, beside the clients rather than under one. */
export const LEGAL_PATH = "/legal";

/** The release notes, reached from a client page's foot and from the palette. */
export const CHANGELOG_PATH = "/changelog";

/** The drafts made before clients existed, which sit under none. */
export const UNASSIGNED_PATH = "/clients/unassigned";

export const UNASSIGNED_TITLE = "Drafts without a client";

export function clientHubPath(clientId: string): string {
  return `${CLIENTS_PATH}/${clientId}`;
}

/** The caller's clients as a trail's step offers them, each keyed by its page. */
export function clientSwitcher(
  clients: readonly { client_id: string; name: string }[],
  currentId: string,
) {
  return {
    name: "Switch client",
    choices: clients.map((client) => ({
      key: clientHubPath(client.client_id),
      label: client.name,
    })),
    current: clientHubPath(currentId),
  };
}

/** Up to two letters for a client with no logo, from the first two words of its name. */
export function initialsOf(name: string): string {
  return name
    .replace(/[^\p{L}\p{N} ]/gu, " ")
    .trim()
    .split(/ +/)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
}
